import { barnToolsApi } from './base';
import { IOrgUsers, IUserCollection, Profile } from './types';

export const userApi = barnToolsApi
  .enhanceEndpoints({ addTagTypes: ['users', 'profile'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getUser: builder.query<Profile, string>({
        query: (oid) => {
          return { url: `profile/${oid}` };
        },
        providesTags: ['profile'],
      }),
      getUsers: builder.query<IUserCollection, void>({
        query: () => `users/`,
        providesTags: ['users'],
      }),
      getUsersByOrg: builder.query<IOrgUsers, string>({
        query: (orgId) => {
          return {
            url: `organizations/${orgId}/users`,
          };
        },
        providesTags: ['users'],
      }),
      addUserToOrg: builder.mutation({
        query: (args: { userId: string; orgId: string; roleId: number }) => {
          return {
            url: `organizations/${args.orgId}/users`,
            method: 'POST',
            body: {
              userId: args.userId,
              roleId: args.roleId,
            },
          };
        },
        invalidatesTags: ['users'],
      }),
      updateUserRole: builder.mutation({
        query: (args: { userId: string; orgId: string; roleId: number }) => {
          return {
            url: `organizations/${args.orgId}/users/${args.userId}`,
            method: 'PUT',
            body: {
              roleId: args.roleId,
            },
          };
        },
        invalidatesTags: ['users'],
      }),
      removeUserFromOrg: builder.mutation({
        query: (args: { userId: string; orgId: string }) => {
          return {
            url: `organizations/${args.orgId}/users/${args.userId}`,
            method: 'DELETE',
          };
        },
        invalidatesTags: ['users'],
      }),
    }),
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetUsersQuery,
  useGetUserQuery,
  useLazyGetUsersQuery,
  useGetUsersByOrgQuery,
  useLazyGetUsersByOrgQuery,
  useAddUserToOrgMutation,
  useUpdateUserRoleMutation,
  useRemoveUserFromOrgMutation,
} = userApi;
